import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { GridItemDirective } from "./grid-item.directive";


@Injectable()
export class GridLayoutService {

    readonly colCountSubject = new BehaviorSubject<number>(1);
    get colCount() {
        return this.colCountSubject.value;
    }

    readonly spacingSubject = new BehaviorSubject<number>(10);

    readonly gridItemsSubject = new BehaviorSubject<GridItemDirective[]>(undefined)
    get gridItems() {
        return this.gridItemsSubject.value;
    }

    isLastInRow(itemIdx: number) {

        if (this.colCount === 1) {
            return true;
        }

        const prevItems = this.gridItems.filter((_, idx) => idx < itemIdx)
        const prevUsedCols = prevItems.reduce((total, current) => total + Math.min(this.colCount, current.colSpan || 1), 0);

        const thisRowUsedCols = prevUsedCols % this.colCount;

        const currentCols = this.gridItems[itemIdx].colSpan || 1;


        if (thisRowUsedCols + currentCols < this.colCount) {
            return false;
        }

        if (thisRowUsedCols + currentCols === this.colCount) {
            return true;
        }

        return currentCols === this.colCount;

    }

    getSpacing(itemIdx: number) {

        if (itemIdx === -1 || this.isLastInRow(itemIdx)) {
            return 0;
        }

        return this.spacingSubject.value
    }
}   
